import React, { useState } from 'react';
import { Grid, Button, CircularProgress, Typography, makeStyles } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GetAppIcon from '@material-ui/icons/GetApp';
import { ImcGenericStyle } from '../ImcGeneric/ImcGenericStyle';
import { useParams } from 'react-router-dom';

export default function FiltroDate({ fechainicial, fechafinal, handlerFilter, isLoading, setDateInit, setDateEnd }) {
  const initialDate = new Date(fechainicial);
  const finalDate = new Date(fechafinal);
  const [dataStart, setDataStart] = useState(initialDate);
  const [dataEnd, setDataEnd] = useState(finalDate);

  const classes = ImcGenericStyle();
  const { id } = useParams();
  const bascula = id === undefined || id === null || id === ":id" || id === "poll" ? 0 : id;

  const handleDateChange = (date) => {
    setDataStart(date);
  };

  const handleDateEnd = (date) => {
    setDataEnd(date);
  };

  const handerSendFilter = () => {
    const formattedStartDate = formatDate(dataStart);
    const formattedEndDate = formatDate(dataEnd);
    handlerFilter(dataStart, dataEnd);
    setDateInit(formattedStartDate)
    setDateEnd(formattedEndDate)
  };

  const downloadReport = () => {
    const formattedStartDate = formatDate(dataStart);
    const formattedEndDate = formatDate(dataEnd);
    window.open(`${process.env.REACT_APP_API_EVBI}/v1/alcoholimetro/export/historic/evbi/dates/${bascula}/${formattedStartDate}/${formattedEndDate}`);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Asegura que el mes tenga dos dígitos
    const day = date.getDate().toString().padStart(2, '0'); // Asegura que el día tenga dos dígitos
    return `${year}-${month}-${day}`;
  };

  const customDatePickerMonthNavIcons = makeStyles((theme) => ({
    root: {
      '& .MuiSvgIcon-root': {
        fill: theme.palette.primary.main,
      },
    },
  }));

  return (
    <>
      <Typography align="center" variant="h4" style={{ fontSize: "35pt", fontWeight: 'bold' }} color='primary'>
        Filtros
      </Typography>

      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid container spacing={1} style={{ maxWidth: '100%', margin: '0 auto', textAlign: 'center', height: '120px' }}>
          <Grid item xs={12} sm={6} md={3}>
            <KeyboardDatePicker
              type='fechas'
              disableToolbar
              variant="inline"
              format="yyyy-MM-dd"
              margin="normal"
              id="date-picker-inline"
              label="Fecha inicial"
              value={dataStart}
              style={{ textTransform: "none", width: "100%" }}
              onChange={handleDateChange}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={customDatePickerMonthNavIcons().root}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <KeyboardDatePicker
              type='fechas'
              disableToolbar
              variant="inline"
              format="yyyy-MM-dd"
              minDate={dataStart}
              margin="normal"
              id="date-picker-inline"
              label="Fecha Final"
              value={dataEnd}
              style={{ textTransform: "none", width: "100%" }}
              onChange={handleDateEnd}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              className={customDatePickerMonthNavIcons().root}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} style={{ marginTop: '1%' }}>
            <div className={classes.wrapper}>
              <Button
                disabled={isLoading}
                type="submit"
                variant="contained"
                color="primary"
                onClick={() => handerSendFilter()}
                style={{ textTransform: "none", width: "45%" }}
              >
                Filtro
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={downloadReport}
                startIcon={<GetAppIcon />}
                style={{ backgroundColor: "#2bb673", width: '45%', marginLeft: '2%' }}
              >
                <span style={{ marginLeft: '8px' }}>Descargar</span>
              </Button>
              {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
            </div>
          </Grid>
        </Grid>
      </MuiPickersUtilsProvider>
    </>
  );
}
